var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.6665,
    y: 4.16667,
    width: 6.66667,
    height: 11.6667,
    rx: 1,
    fill: "#93EDBF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5.90126C2.5 5.07424 2.5 4.66072 2.74455 4.37876C2.98909 4.0968 3.39845 4.03832 4.21716 3.92136L11.8838 2.82612C12.946 2.67438 13.4771 2.59851 13.8219 2.89756C14.1667 3.1966 14.1667 3.73307 14.1667 4.80602V15.194C14.1667 16.2669 14.1667 16.8034 13.8219 17.1024C13.4771 17.4015 12.946 17.3256 11.8838 17.1739L4.21716 16.0786C3.39845 15.9617 2.98909 15.9032 2.74455 15.6212C2.5 15.3393 2.5 14.9258 2.5 14.0987V5.90126Z",
    fill: "#15BD66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28874 12.2441L8.28208 10.6774L7.36874 12.2441H6.31541L7.78208 9.89744L6.29541 7.59077H7.36874L8.37541 9.15078L9.28208 7.59077H10.3354L8.87541 9.93078L10.3621 12.2441H9.28874Z",
    fill: "#EBFAEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.f755fc33ce5e87157f3718470d6f32b1.svg";
export { ForwardRef as ReactComponent };